// Logo Configuration
// Change your logo and site name here!

export const LOGO_CONFIG = {
  // Site name
  siteName: "The Archive",
  
  // Logo settings
  useLogo: true,  // Using the 2RA-Edition logo!
  logoPath: "/logo.png",  // PNG version with transparency
  logoIconPath: "/logo.png",  // Same for icon
  
  // Display settings
  showIcon: false,  // Don't show book icon (we have logo!)
  showText: true,  // Show "The Archive" text
  
  // Styling
  logoHeight: "h-12",  // Fits within the 64px navbar (h-24 overflowed onto nav links)
  iconSize: "w-12 h-12",
  textSize: "text-3xl",
  fontFamily: "font-semibold",
};

// Logo appears AFTER "The Archive" text


